import { motion } from "framer-motion";
import { HOUSE } from "@/constants/testIds";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] },
};

export const Vision = () => {
  return (
    <section
      id="vision"
      data-testid={HOUSE.sectionVision}
      className="relative bg-[var(--black)] py-28 md:py-40 border-t border-[var(--border-dark)] overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none opacity-[0.06]" aria-hidden>
        <div
          className="absolute -top-40 -right-40 w-[700px] h-[700px] rounded-full"
          style={{
            background:
              "radial-gradient(closest-side, rgba(139,115,85,0.9) 0%, transparent 70%)",
          }}
        />
      </div>

      <div className="relative max-w-[1200px] mx-auto px-6 md:px-12">
        <motion.p
          {...fadeUp}
          className="font-sans text-[11px] uppercase tracking-[0.5em] text-[var(--gold-light)] mb-10"
        >
          The House of BorsaLux
        </motion.p>

        <motion.h2
          {...fadeUp}
          transition={{ ...fadeUp.transition, delay: 0.08 }}
          className="font-serif text-[var(--ivory)] text-4xl sm:text-5xl lg:text-6xl leading-[1.08] tracking-tight font-light max-w-4xl"
        >
          The Abike Collection is where the story begins.
        </motion.h2>

        <motion.div
          {...fadeUp}
          transition={{ ...fadeUp.transition, delay: 0.16 }}
          className="mt-12 max-w-2xl space-y-6 font-sans text-[var(--stone)] text-lg leading-relaxed"
        >
          <p>
            The House of BorsaLux is building a broader design philosophy
            around intentional placement — the belief that thoughtfully
            designed environments should consider not only the people who
            enter them, but also the things they carry.
          </p>
          <p className="text-[var(--ivory)] font-serif italic text-xl md:text-2xl leading-relaxed">
            Everything deserves a place.
          </p>
        </motion.div>
      </div>
    </section>
  );
};
